
    import Vue from "vue";
    import { Component, Prop } from "vue-property-decorator";
    import ApiButton from "@/vue/components/ApiButton.vue";

    @Component({ components: { ApiButton } })
    export default class ConfirmDialog extends Vue {

        //
        // -- properties
        //

        @Prop() busyEventName?: string;

        @Prop({ default: "Are you sure?" }) title!: string;
        @Prop({ default: "Are you sure you want to continue?" }) text!: string;
        @Prop({ default: "Yes, Do It" }) yesButtonText!: string;
        @Prop({ default: "mdi-check"}) yesButtonIcon!: string;
        @Prop({ default: "No, cancel" }) noButtonText!: string;
        @Prop({ default: "mdi-cancel" }) noButtonIcon!: string;
        @Prop({ default: "I know what I'm doing!" }) checkboxPrompt!: string;
        @Prop({ default: false }) showCheckbox!: boolean;

        showDialog: boolean = false;

        isCheckboxChecked: boolean = false;

        confirmCallback: (() => void)|null = null;

        //
        // -- methods
        //

        show() {
            this.confirmCallback = null;
            this.isCheckboxChecked = false;
            this.showDialog = true;
        }

        showWithConfirmCallback(callback: () => void) {
            this.confirmCallback = callback;
            this.isCheckboxChecked = false;
            this.showDialog = true;
        }

        hide () {
            this.showDialog = false;
        }

        cancel() {
            this.$emit("cancel");
            this.showDialog = false;
        }

        confirm() {
            if(this.confirmCallback != null) this.confirmCallback();
            this.$emit("confirm");
            this.showDialog = false;
        }

    }
